const state = {
  // 是否折叠
  isCollapse: false,
  // 菜品编码
  productArr: '',
  logicParams: {},

  // 单选/多选扩展项
  extensionArr: [],
  formTitle: ''
}

const getters = {
  isCollapse: (state) => {
    return state.isCollapse
  },
  formTitle: (state) => {
    return state.formTitle
  }
}

const actions = {
  setIsCollapse(context, payload) {
    return new Promise((resolve) => {
      // 模拟登录成功，写入 token 信息
      context.commit('setIsCollapse', payload)
      resolve()
    })
  },
  setProductArr(context, payload) {
    return new Promise((resolve) => {
      context.commit('PRODUCT_ARR', payload)
      resolve()
    })
  },
  setLogicParams(context, payload) {
    return new Promise((resolve) => {
      context.commit('LOGIC_PARAMS', payload)
      resolve()
    })
  },
  setExtensionArr(context, payload) {
    return new Promise((resolve) => {
      context.commit('EXTENSION_ARR', payload)
      resolve()
    })
  },
  setFormTitle(context, payload) {
    return new Promise((resolve) => {
      context.commit('FORM_TITLE', payload)
      resolve()
    })
  }
}

const mutations = {
  setIsCollapse(state, status) {
    state.isCollapse = status
  },
  PRODUCT_ARR(state, status) {
    state.productArr = status
  },
  LOGIC_PARAMS(state, status) {
    state.logicParams = status
  },
  EXTENSION_ARR(state, status) {
    state.extensionArr = status
  },
  FORM_TITLE(state, status) {
    state.formTitle = status
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
